


















































































































import { Component, Vue } from "vue-property-decorator";
import Agenda from "../views/Agenda.vue";
import ProgressMode from "../views/ProgressMode.vue";
import { DxSwitch } from "devextreme-vue/switch";

@Component({
  components: {
    Agenda,
    ProgressMode,
    DxSwitch,
  },
})
export default class Overview extends Vue {
  private showProgressMode: boolean = false;
}
